import React from 'react'
import './style/head.css'
import logo from '../../assets/Logo.png'
import { NavLink } from 'react-router-dom'

export default function Head() {
  return (
    <div className="head_all">
      <div className="head">
        <div className="head_left">
          <img src={logo} alt="" />
        </div>
        <div className="head_center">
          <ul>
            <li className="active">
              <NavLink to={''}>首页</NavLink>
            </li>
            <li>
              <NavLink to="window">WIN软件</NavLink>
            </li>
            <li>
              <NavLink to="mac">MAC软件</NavLink>
            </li>
            <li>
              <NavLink to="game">游戏</NavLink>
            </li>
          </ul>
        </div>
        {/* <div className="head_right">
          <div className="search">
            <input type="text" placeholder="  搜索网页" />
            <img src={sosuo} alt="" />
          </div>
        </div> */}
      </div>
    </div>
  )
}
